import $ from "jquery";

const miTabsScrollback = () => {
  const el = {
    container: ".mi-tabs",
    target: ".mi-tabs .e-n-tab-title",
  };

  const init = () => {
    $(function () {
      if (!$(el.target).length) return;
      exec();
    });
  };

  const exec = () => {
    $(el.target).on('click', function (event) {
      // Programmatic clicks are already scrolled by mi-tabs-navigation.
      if (!event.originalEvent) return;

      const navHeight = $('.mi-navbar--main, header.site-header, header').outerHeight() || 80;
      const adminBarHeight = $('#wpadminbar').outerHeight() || 0;
      const top = Math.ceil($(el.container).offset().top - navHeight - adminBarHeight);
      const stopScrollAnimation = () => $('html, body').stop(true, false);

      stopScrollAnimation();
      window.scrollTo({ top, behavior: 'auto' });

      // Elementor may start its delegated scroll animation after this handler.
      requestAnimationFrame(() => {
        stopScrollAnimation();
        window.scrollTo({ top, behavior: 'auto' });
      });
    })
  };

  init();
};

try {
  miTabsScrollback();
} catch (error) {
  console.error(error);
}
